import React from 'react'
import Card from 'react-bootstrap/Card'
import CreatedCard, { createdHref } from './created-card'

// Everything the conversation created or pulled in, once each, newest first — kept beside the chat
// so it isn't lost in the scroll.
export const createdLinks = (events = []) => {
  const byHref = new Map()
  events
    .filter((event) => event.type === 'action' && createdHref(event.payload?.link))
    .forEach((event) => {
      const href = createdHref(event.payload.link)
      byHref.delete(href)
      byHref.set(href, event.payload.link)
    })
  return [...byHref.values()].reverse()
}

const CreatedPanel = ({ events }) => {
  const links = createdLinks(events)
  if (links.length === 0) return null

  return (
    <Card body data-testid="ask-created-panel">
      <div className="small text-muted text-uppercase fw-semibold mb-2 px-2">Created</div>
      {links.map((link) => (
        <CreatedCard key={createdHref(link)} link={link} wrap />
      ))}
    </Card>
  )
}

export default CreatedPanel
